import React, { useState } from "react";
import { Form, Input, Button, Card, Spin } from "antd";
import { LoadingOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import logo from "../../assets/images/logoGF.png";
import Theme from "../../theme/Theme";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import ResetPasswordApi from "../../api/auth/ResetPasswordApi";

function ResetPassword() {
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const [submit, setSubmit] = useState(false);
  const { token } = useParams();

  function strongPassword(password) {
    let strength = false;
    const passwordArray = password.split("");
    let lowercase = false;
    let uppercase = false;
    let number = false;
    let length = false;
    // Validate lowercase letters
    const lowerCaseLetters = /[a-z]/g;
    passwordArray.forEach((pass) => {
      if (pass.match(lowerCaseLetters)) {
        lowercase = true;
      }
    });
    // Validate capital letters
    const upperCaseLetters = /[A-Z]/g;
    passwordArray.forEach((pass) => {
      if (pass.match(upperCaseLetters)) {
        uppercase = true;
      }
    });
    // Validate numbers
    const numbers = /[0-9]/g;
    passwordArray.forEach((pass) => {
      if (pass.match(numbers)) {
        number = true;
      }
    });
    // Validate length
    if (passwordArray.length >= 8) {
      length = true;
    }
    if (lowercase && uppercase && number && length) {
      strength = true;
    }

    return strength;
  }

  async function onFinish(values) {
    setSubmit(true);
    if (!strongPassword(values.password)) {
      form.setFields([
        {
          name: "password",
          errors: ["Enter a strong password!"],
        },
      ]);
    } else if (values.password !== values.confirmPassword) {
      form.setFields([
        {
          name: "confirmPassword",
          errors: ["Password doesn't match!"],
        },
      ]);
    } else {
      const apiResponse = await ResetPasswordApi(
        values.password,
        values.confirmPassword,
        token
      );
      if (apiResponse.error) {
        openNotificationError(
          "bottomRight",
          apiResponse?.message
        );
      } else {
        openNotificationSuccess("bottomRight", apiResponse.message);
        navigate(`/login`);
      }
    }
    setSubmit(false);
  }

  return (
    <>
      <div
        className="flex w-full h-full items-center justify-center"
        style={{ backgroundColor: "#fff" }}
      >
        <div className="w-full max-w-lg p-3">
          <div className="text-center mb-6">
            <img className="w-48 mx-auto" src={logo} alt="logo" />
          </div>
          <Card
            style={{
              borderColor: "#e5e7eb",
              cursor: "pointer",
            }}
          >
            <div className="text-2xl pri-font text-center mb-2">
              Reset your password
            </div>
            <div className="mb-4 text-xs text-center">
              Your password must be at least 8 characters long, contain at least
              one number, one uppercase letter and one lowercase letter.
            </div>
            <Form
              name="resetPassword"
              onFinish={onFinish}
              form={form}
              className="w-full max-w-lg"
              validateMessages={"validateMessages"}
            >
              <Form.Item name="password">
                <Input
                  prefix={<LockOutlined style={{ color: Theme().primary }} />}
                  type="password"
                  placeholder="New Password"
                />
              </Form.Item>

              <Form.Item name="confirmPassword">
                <Input
                  prefix={<LockOutlined style={{ color: Theme().primary }} />}
                  type="password"
                  placeholder="Confirm Password"
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  htmlType={submit && "submit"}
                  className="w-full"
                >
                  {submit ? (
                    <Spin
                      size="small"
                      indicator={
                        <LoadingOutlined style={{ color: "#fff" }} spin />
                      }
                    />
                  ) : (
                    "Reset Password"
                  )}
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
